export const SHOW_NOTIFICATON = 'SHOW_NOTIFICATON';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
